import React, { useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { removeToken } from "../ auth";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import logo from "../assets/img/logoN.png"

export default function DashboardLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showCard, setShowCard] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const toggleCard = () => {
    setShowCard(!showCard);
  };

  const handleLogout = () => {
    removeToken();
    navigate("/");
  };

  return (
    <div className="d-flex h-100 bg-light">
      {/* Barre horizontale pour mobile */}
      <nav className="d-lg-none bg-dark text-white shadow-sm w-100" style={{ zIndex: 1000, position: "fixed", top: 0 }}>
        <div className="container-fluid">
          <div className="d-flex align-items-center justify-content-between flex-wrap py-2">
            <div
              className="d-flex align-items-center cursor-pointer"
              onClick={() => navigate("/dashboard")}
              style={{ cursor: "pointer" }}
            >
              <img src={logo} alt="logo" style={{ height: "40px", marginRight: "10px" }} />
              <span className="fs-6 fw-bold">Tableau de bord</span>
            </div>
            <button
              className="btn btn-outline-light"
              type="button"
              onClick={() => setIsOpen(!isOpen)}
            >
              <i className={`bi ${isOpen ? "bi-x" : "bi-list"}`}></i>
            </button>
          </div>
          {/* Menu déroulant mobile */}
          <div className={`${isOpen ? "d-block" : "d-none"} pb-2`}>
            <div className="d-flex flex-column gap-2">
              <button
                className={`btn text-white text-start w-100 ${isActive("/dashboard/requirements") ? "fw-bold bg-secondary" : ""}`}
                onClick={() => {
                  navigate("/dashboard/requirements");
                  setIsOpen(false);
                }}
              >
                <i className="bi bi-list-check me-2"></i>Exigences
              </button>
              <button
                className={`btn text-white text-start w-100 ${isActive("/dashboard/proofs") ? "fw-bold bg-secondary" : ""}`}
                onClick={() => {
                  navigate("/dashboard/proofs");
                  setIsOpen(false);
                }}
              >
                <i className="bi bi-upload me-2"></i>Preuves
              </button>
              <button
                className={`btn text-white text-start w-100 ${isActive("/dashboard/memoire") ? "fw-bold bg-secondary" : ""}`}
                onClick={() => {
                  navigate("/dashboard/memoire");
                  setIsOpen(false);
                }}
              >
                <i className="bi bi-file-earmark-text me-2"></i>Soumettre mémoire
              </button>
              <button
                className={`btn text-white text-start w-100 ${isActive("/dashboard/progression") ? "fw-bold bg-secondary" : ""}`}
                onClick={() => {
                  navigate("/dashboard/progression");
                  setIsOpen(false);
                }}
              >
                <i className="bi bi-bar-chart-line me-2"></i>Progression
              </button>
              <button
                className={`btn text-white text-start w-100 ${isActive("/dashboard/investitures") ? "fw-bold bg-secondary" : ""}`}
                onClick={() => {
                  navigate("/dashboard/investitures");
                  setIsOpen(false);
                }}
              >
                <i className="bi bi-award me-2"></i>Investitures
              </button>
              <button 
                className="btn btn-outline-danger btn-sm" 
                onClick={handleLogout}
              >
                <i className="bi bi-box-arrow-left me-1"></i>Déconnexion
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar vertical pour desktop */}
      <div
        className="d-none d-lg-flex flex-column bg-dark text-white p-3"
        style={{ width: "250px", minHeight: "100vh" }}
      >
        <h4 className="mb-4 text-center">
          <img src={logo} alt="logo"/>
        </h4>
        <ul className="nav nav-pills flex-column">
          <li className="nav-item mb-2">
            <button
              className={`btn text-start text-white w-100 ${isActive("/dashboard/requirements") ? "fw-bold" : ""}`}
              onClick={() => navigate("/dashboard/requirements")}
            >
              <i className="bi bi-list-check me-2 text-info"></i>Exigences
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className={`btn text-start text-white w-100 ${isActive("/dashboard/proofs") ? "fw-bold" : ""}`}
              onClick={() => navigate("/dashboard/proofs")}
            >
              <i className="bi bi-upload me-2 text-info"></i>Preuves
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className={`btn text-start text-white w-100 ${isActive("/dashboard/memoire") ? "fw-bold" : ""}`}
              onClick={() => navigate("/dashboard/memoire")}
            >
              <i className="bi bi-file-earmark-text me-2 text-info"></i>Soumettre mémoire
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className={`btn text-start text-white w-100 ${isActive("/dashboard/progression") ? "fw-bold" : ""}`}
              onClick={() => navigate("/dashboard/progression")}
            >
              <i className="bi bi-bar-chart-line me-2 text-info"></i>Progression
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className={`btn text-start text-white w-100 ${isActive("/dashboard/investitures") ? "fw-bold" : ""}`}
              onClick={() => navigate("/dashboard/investitures")}
            >
              <i className="bi bi-award me-2 text-info"></i>Investitures
            </button>
          </li>
        </ul>

        <div className="mt-auto pt-4">
          <button
            className="btn btn-outline-danger w-100"
            onClick={handleLogout}
          >
            <i className="bi bi-box-arrow-left me-2"></i>Déconnexion
          </button>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-grow-1 p-4 bg-white" style={{ marginTop: isOpen ? "200px" : "0" }}>
        <header className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
          <h2 className="text-primary m-0 text-center flex-grow-1">
            <i className="bi bi-grid me-2"></i>Tableau de bord élève
          </h2>
          <div className="position-relative">
            <button className="btn btn-sm btn-primary" onClick={toggleCard}>
              <i className="bi bi-person-circle"></i>
            </button>
            {showCard && (
              <div
                className="card shadow position-absolute end-0 mt-2"
                style={{ minWidth: "220px", zIndex: 1000 }}
              >
                <div className="card-body">
                  <h6 className="card-title mb-1">👤 Nom de l'utilisateur</h6>
                  <p className="mb-1 text-muted">📧 email@exemple.com</p>
                  <span className="badge bg-info text-dark">élève</span>
                </div>
              </div>
            )}
          </div>
        </header>

        <Outlet />
      </div>
    </div>
  );
}
